// eslint-disable-next-line @typescript-eslint/naming-convention
export const DelayLevel = {
    NoDelay: 0,
    ShortDelay: 1,
    MediumDelay: 2,
    SevereDelay: 3
} as const;

export type DelayLevelType = (typeof DelayLevel)[keyof typeof DelayLevel];
